import { Reducer } from 'redux';
import { TerminalBlocksState, TerminalBlocksTypes } from './types';

export const INITIAL_STATE: TerminalBlocksState = {
  terminalBlockData: {
    id: '',
    terminalId: '',
    name: '',
    bounds: [],
    createdAt: '',
    updatedAt: '',
  },
  terminalBlockScheduleData: {
    id: '',
    terminalId: '',
    name: '',
    bounds: [],
    createdAt: '',
    updatedAt: '',
  },
  toggleTerminalPanic: null,
  terminalBlocksList: [],
  toggleBlockScheduleStatus: {
    id: '',
    title: '',
    status: null,
    weekdays: '',
    validFrom: null,
    type: null,
    createdAt: null,
    updatedAt: null,
    blockId: '',
  },
  totalCount: 0,
  loading: false,
  error: false,
};

const reducer: Reducer<TerminalBlocksState> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    // CASES LIST TERMINAL BLOCKS
    case TerminalBlocksTypes.LIST_TERMINAL_BLOCKS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        terminalBlocksList: INITIAL_STATE.terminalBlocksList,
      };
    case TerminalBlocksTypes.LIST_TERMINAL_BLOCKS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        totalCount: action.payload.totalCount,
        terminalBlocksList: action.payload.terminalBlocksList,
      };
    case TerminalBlocksTypes.LIST_TERMINAL_BLOCKS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        terminalBlocksList: INITIAL_STATE.terminalBlocksList,
      };

    // CASES TOGGLE_BLOCK_SCHEDULE_STATUS
    case TerminalBlocksTypes.TOGGLE_BLOCK_SCHEDULE_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        toggleBlockScheduleStatus: INITIAL_STATE.toggleBlockScheduleStatus,
      };
    case TerminalBlocksTypes.TOGGLE_BLOCK_SCHEDULE_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        toggleBlockScheduleStatus: action.payload.toggleBlockScheduleStatus,
      };
    case TerminalBlocksTypes.TOGGLE_BLOCK_SCHEDULE_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        toggleBlockScheduleStatus: INITIAL_STATE.toggleBlockScheduleStatus,
      };

    // CASES TOGGLE_TERMINAL_PANIC_REQUEST
    case TerminalBlocksTypes.TOGGLE_TERMINAL_PANIC_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        toggleTerminalPanic: INITIAL_STATE.toggleTerminalPanic,
      };
    case TerminalBlocksTypes.TOGGLE_TERMINAL_PANIC_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        toggleTerminalPanic: action.payload.toggleTerminalPanic,
      };
    case TerminalBlocksTypes.TOGGLE_TERMINAL_PANIC_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        toggleTerminalPanic: INITIAL_STATE.toggleTerminalPanic,
      };

    // CASES CREATE_BLOCK_SCHEDULE
    case TerminalBlocksTypes.CREATE_BLOCK_SCHEDULE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        terminalBlockScheduleData: INITIAL_STATE.terminalBlockScheduleData,
      };
    case TerminalBlocksTypes.CREATE_BLOCK_SCHEDULE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        terminalBlockScheduleData: action.payload.terminalBlockScheduleData,
      };
    case TerminalBlocksTypes.CREATE_BLOCK_SCHEDULE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        terminalBlockScheduleData: INITIAL_STATE.terminalBlockScheduleData,
      };

    // CASES UPDATE_BLOCK_SCHEDULE_REQUEST
    case TerminalBlocksTypes.UPDATE_BLOCK_SCHEDULE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        terminalBlockScheduleData: INITIAL_STATE.terminalBlockScheduleData,
      };
    case TerminalBlocksTypes.UPDATE_BLOCK_SCHEDULE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        terminalBlockScheduleData: action.payload.terminalBlockScheduleData,
      };
    case TerminalBlocksTypes.UPDATE_BLOCK_SCHEDULE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        terminalBlockScheduleData: INITIAL_STATE.terminalBlockScheduleData,
      };

    // CASES DELETE_BLOCK_SCHEDULE
    case TerminalBlocksTypes.DELETE_BLOCK_SCHEDULE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case TerminalBlocksTypes.DELETE_BLOCK_SCHEDULE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case TerminalBlocksTypes.DELETE_BLOCK_SCHEDULE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // CASES BLOCK_SCHEDULE_GATE_CREATE
    case TerminalBlocksTypes.BLOCK_SCHEDULE_GATE_CREATE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        terminalBlockScheduleData: INITIAL_STATE.terminalBlockScheduleData,
      };
    case TerminalBlocksTypes.BLOCK_SCHEDULE_GATE_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        terminalBlockScheduleData: action.payload.terminalBlockScheduleData,
      };
    case TerminalBlocksTypes.BLOCK_SCHEDULE_GATE_CREATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        terminalBlockScheduleData: INITIAL_STATE.terminalBlockScheduleData,
      };

    // CASES GET TERMINAL BLOCK
    case TerminalBlocksTypes.GET_TERMINAL_BLOCK_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        terminalBlockData: INITIAL_STATE.terminalBlockData,
      };
    case TerminalBlocksTypes.GET_TERMINAL_BLOCK_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        terminalBlockData: action.payload.terminalBlockData,
      };
    case TerminalBlocksTypes.GET_TERMINAL_BLOCK_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        terminalBlockData: INITIAL_STATE.terminalBlockData,
      };

    // CASES FILTER TERMINAL BLOCKS
    case TerminalBlocksTypes.FILTER_TERMINAL_BLOCKS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        terminalBlocksList: INITIAL_STATE.terminalBlocksList,
      };
    case TerminalBlocksTypes.FILTER_TERMINAL_BLOCKS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        totalCount: action.payload.totalCount,
        terminalBlocksList: action.payload.terminalBlocksList,
      };
    case TerminalBlocksTypes.FILTER_TERMINAL_BLOCKS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        terminalBlocksList: INITIAL_STATE.terminalBlocksList,
      };

    // CASES CREATE TERMINAL BLOCK
    case TerminalBlocksTypes.CREATE_TERMINAL_BLOCK_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        terminalBlockData: INITIAL_STATE.terminalBlockData,
      };
    case TerminalBlocksTypes.CREATE_TERMINAL_BLOCK_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        terminalBlockData: action.payload.terminalBlockData,
      };
    case TerminalBlocksTypes.CREATE_TERMINAL_BLOCK_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        terminalBlockData: INITIAL_STATE.terminalBlockData,
      };

    // CASES UPDATE TERMINAL BLOCK
    case TerminalBlocksTypes.UPDATE_TERMINAL_BLOCK_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        terminalBlockData: INITIAL_STATE.terminalBlockData,
      };
    case TerminalBlocksTypes.UPDATE_TERMINAL_BLOCK_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        terminalBlockData: action.payload.terminalBlockData,
      };
    case TerminalBlocksTypes.UPDATE_TERMINAL_BLOCK_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        terminalBlockData: INITIAL_STATE.terminalBlockData,
      };

    // CASES DELETE TERMINAL BLOCK
    case TerminalBlocksTypes.DELETE_TERMINAL_BLOCK_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case TerminalBlocksTypes.DELETE_TERMINAL_BLOCK_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case TerminalBlocksTypes.DELETE_TERMINAL_BLOCK_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    default:
      return { ...state };
  }
};

export default reducer;
